Bingo.Tooltip = {};

Bingo.Tooltip.init = function () {
    if ($('[data-toggle="tooltip"]').parents('.extra-services').length > 0) {
        $('[data-toggle="tooltip"]').tooltip({
            template: '<div class="M-tooltip -extraServices" role="tooltip"><div class="M-tooltip__arrow"></div><div class="M-tooltip__inner tooltip-inner"></div></div>',
        });
    } else if ($('[data-toggle="tooltip"]').parents('.A-mapInfoBox').length > 0) {
        $('[data-toggle="tooltip"]').tooltip({
            template: '<div class="M-tooltip" role="tooltip"><div class="M-tooltip__arrow"></div><div class="M-tooltip__inner tooltip-inner"></div></div>',
        });
    } else {
        $('body').tooltip({
            selector: '[data-toggle="tooltip"]',
            template: '<div class="M-tooltip" role="tooltip"><div class="M-tooltip__arrow"></div><div class="M-tooltip__inner tooltip-inner"></div></div>',
        });
    }
};
